/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Tool_Grants_Grant_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not grant the tool." |
*
* @param {Spaces_Tool_Grants_Grant_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_tool_grants_grant_error = /** @type {((inputs?: Spaces_Tool_Grants_Grant_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Tool_Grants_Grant_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Tool konnte nicht freigegeben werden.")
	return /** @type {LocalizedString} */ ("Could not grant the tool.")
});